import { css, Global } from '@emotion/react';

export function DevToolsCSSReset() {
  return (
    <Global
      styles={css`
        .remix-dev-tools * {
          color: var(--colors-warmgrey300);
        }
      `}
    />
  );
}
